import React from 'react';
import PropTypes from 'prop-types';
import IconHexagon from '@learningblocks/exp-constants/lib/Icons/hexagon-solid';
import {NOTEBOOK_SECTIONS} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';

/**
 * Menu : A single menu item in section listing
 */
export function Menu(props) {
  const isCurrent = () => props.current;

  const isDesignSection = () => props.title === NOTEBOOK_SECTIONS.DESIGN;

  const getClassName = () =>
    isCurrent() ? 'sectionMenu_current' : 'sectionMenu';

  const menuArrow = () =>
    isCurrent() && !isDesignSection() && <div className='arrow' />;

  const goToSection = () => {
    let current = isCurrent();
    if (!current) {
      props.goToSection(props.value);
    }
    if (current && isDesignSection()) {
      props.goToFirstSection();
    }
  };

  return (
    <div className={getClassName()} onClick={goToSection}>
      {menuArrow()}
      <div className='index'>
        <span className='index-icon'>
          <IconHexagon />
        </span>
        <span className='index-number'>{props.number}</span>
      </div>
      <div className='title'>{props.title}</div>
    </div>
  );
}

Menu.propTypes = {
  /**
   * Title to display in  menu
   */
  title: PropTypes.string.isRequired,
  /**
   * Boolean specifying if menu is selected
   */
  current: PropTypes.bool.isRequired,
  /**
   * Index number of menu
   */
  number: PropTypes.number.isRequired,
  /**
   * Unique string value of the menu
   */
  value: PropTypes.string.isRequired,
  /**
   * Function to invoke when a Menu is clicked
   */
  goToSection: PropTypes.func.isRequired,
  /**
   * Function to invoke when DesignMenu is cliked while
   * in DesignSection View
   */
  goToFirstSection: PropTypes.func.isRequired,
};

Menu.defaultProps = {
  title: '',
  current: false,
  number: 0,
  value: '',
  goToSection: () => {},
  goToFirstSection: () => {},
};
